import type { GrantInput } from '@/graphql/brokerages';
import type { Grant } from '@/lib/brokerage-permissions';

/** The assignments and removals that turn `from` into `to`. */
export function roleChanges(
  from: readonly string[],
  to: readonly string[],
): { add: string[]; remove: string[] } {
  return {
    add: to.filter((id) => !from.includes(id)),
    remove: from.filter((id) => !to.includes(id)),
  };
}

const cell = (grant: Grant) => `${grant.resource}|${grant.condition ?? 'ALWAYS'}|${grant.level}`;

/** Whether two grant lists say the same thing, in any order. */
export function sameGrants(a: readonly Grant[], b: readonly Grant[]): boolean {
  const left = new Set(a.map(cell));
  return a.length === b.length && b.every((grant) => left.has(cell(grant)));
}

export function toGrantInputs(grants: readonly Grant[]): GrantInput[] {
  return grants.map(({ resource, level, condition }) => ({
    resource,
    level,
    condition: condition ?? 'ALWAYS',
  }));
}
